
import {
  subscribeBox,
  DEFAULT_SUBSCRIBE_DESCRIPTION,
  DEFAULT_SUBSCRIBE_DOWNLOAD_TEXT,
} from '@/utils/subscribe-box'

export default {
  name: 'CardSubscribe',
  data() {
    return {
      seo: {
        title: '',
        BirincilKampanya: 'Default-Campaign',
      },
      form: {
        fullname: '',
        company: '',
        email: '',
        phone: '',
        countryCode: '',
        bulten_check : false,
        privacy_check: false,
        campaign_check: false,
       

      },
      isInvalid: {
        fullname: false,
        company: false,
        email: false,
        phone: false,
        bulten_check : false,
        privacy_check: false,
        campaign_check: false,
       
      },
      success: false,
    }
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    downloadText: {
      type: String,
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: 'E-postanızı yazınız',
    },
    buttonLabel: {
      type: String,
      default: 'Gönder',
    },
    bultenText: {
      type: String,
      default:
        'Blog bülten aboneliği kapsamında işlenecek kişisel verileriniz ile ilgili detaylı bilgiye <a href="https://www.mikro.com.tr/yasal/#kisisel-veriler-aydinlatma-metni" target="_blank">Aydınlatma Metninini</a> okudum',
    },
    privacyText: {
      type: String,
      default:
        '<a href="https://www.mikro.com.tr/yasal/#kisisel-veriler-aydinlatma-metni" target="_blank">Aydınlatma Metnini</a> uyarınca, kişisel verilerimin aktarılmasına Açık Rıza Metni kapsamında açık rıza veriyorum.',
    },
    campaignText: {
      type: String,
      default:
              'Ticari elektronik ileti gönderimi için <a href="https://www.mikro.com.tr/yasal/#kisisel-veriler-aydinlatma-metni" target="_blank">Açık Rıza Metni</a> kapsamında, e-posta adresimin yurt dışına aktarılmasına onay veriyorum.'
    },
    
    placeholderEmail: {
      type: String,
      default: 'E-postanızı yazınız',
    },

  },

  computed: {
    displayDescription() {
      return this.description || subscribeBox.text || DEFAULT_SUBSCRIBE_DESCRIPTION
    },
    displayDownloadText() {
      return this.downloadText || subscribeBox.downloadText || DEFAULT_SUBSCRIBE_DOWNLOAD_TEXT
    },
  },

  methods: {
    isEmail(e) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(String(e))
    },

    submitSubscribeForm() {
      try {
        if (this.checkAllFields() === true) {
          this.success = true

          let data = {
            email: this.form.email,
            privacy_check: this.form.privacy_check,
            
          }

          // if (process.client) {
          //   const sfData = this.prepareSFData()
          //   data = Object.assign(data, sfData)
          // }

          try {
            this.$axios.post('/subscribe-forms', data)
              .then((response) => {
                console.log("API Success", response.data)
                if (this.$gtm && this.$gtm.pushLeadSubscriptionEvent) {
                  this.$gtm.pushLeadSubscriptionEvent()
                }
              })
              .catch((error) => {
                console.error("API Error", error)
              })
          } catch (error) {
            console.error("API Error:", error)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },

    // prepareSFData function remains the same
    // prepareSFData() {
    //   // ... existing prepareSFData code ...
    //   return {};
    // },

 

    checkAllFields() {
      this.isInvalid.email = this.isEmail(this.form.email)
      this.isInvalid.privacy_check = this.form.privacy_check

      // Scope to this card's root so a sibling form (e.g. a page lead form,
      // which shares input ids/names) is never touched.
      const root = this.$el

      this.isInvalid.email === false
        ? root.querySelector('#email').classList.add('is-invalid')
        : root.querySelector('#email').classList.remove('is-invalid')

      this.isInvalid.bulten_check === false
        ? root.querySelector('input[name="bulten_check"]').parentElement.parentElement.classList.add('is-invalid')
        : root.querySelector('input[name="bulten_check"]').parentElement.parentElement.classList.remove('is-invalid')

        this.isInvalid.privacy_check === false
        ? root.querySelector('input[name="privacy_check"]').parentElement.parentElement.classList.add('is-invalid')
        : root.querySelector('input[name="privacy_check"]').parentElement.parentElement.classList.remove('is-invalid')

        this.isInvalid.campaign_check === false
        ? root.querySelector('input[name="campaign_check"]').parentElement.parentElement.classList.add('is-invalid')
        : root.querySelector('input[name="campaign_check"]').parentElement.parentElement.classList.remove('is-invalid')

      return (
        this.isEmail(this.form.email) === true &&
        this.form.privacy_check === true
      )
    },
  },
}
